import { Svg } from "../../utils/svgIcon";
import { Tooltip } from "../Tooltip";

import leftCollapseSvg from "./icons/panel-left-collapse.svg";
import leftExpandSvg from "./icons/panel-left-expand.svg";
import rightCollapseSvg from "./icons/panel-right-collapse.svg";
import rightExpandSvg from "./icons/panel-right-expand.svg";
import type { PanelSide } from "./PageNavMenuPanel";
import * as theme from "./PageNavMenuToggle.css";

export interface PageNavMenuToggleProps {
    expanded: boolean;
    onExpandedChange: (expanded: boolean) => void;
    /** What a click does next, so it changes with `expanded`. */
    label: string;
    /** The side of the page the toggled panel is on. */
    side?: PanelSide;
    "aria-controls"?: string;
}

const icons = {
    left: { expanded: leftCollapseSvg, collapsed: leftExpandSvg },
    right: { expanded: rightCollapseSvg, collapsed: rightExpandSvg },
} satisfies Record<PanelSide, Record<"expanded" | "collapsed", string>>;

// The tooltip extends towards the page centre, so it stays on screen at either edge.
const tooltipPlacements = {
    left: "bottomLeft",
    right: "bottomRight",
} as const satisfies Record<PanelSide, string>;

export function PageNavMenuToggle({
    expanded,
    onExpandedChange,
    label,
    side = "left",
    "aria-controls": ariaControls,
}: PageNavMenuToggleProps) {
    return (
        <Tooltip title={label} placement={tooltipPlacements[side]} noWrapper>
            <button
                type="button"
                className={theme.root}
                aria-label={label}
                aria-expanded={expanded}
                aria-controls={ariaControls}
                onClick={() => onExpandedChange(!expanded)}
            >
                <Svg
                    src={icons[side][expanded ? "expanded" : "collapsed"]}
                    className={theme.glyph}
                />
            </button>
        </Tooltip>
    );
}
